import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters(['deviceType', 'domainConfig']),
		// 判断是否为页面级组件
		isPageComponent() {
			// 通过检查组件名称或路由匹配来判断是否为页面级组件
			return this.$options.name && this.$route && this.$route.matched.length > 0 && this.$route.matched[0].instances.default === this
		},
	},
	methods: {
		/**
		 * 页面浏览上报方法
		 * @param {Object} extraData - 额外的上报数据，可选
		 * @returns {Promise} - 上报请求的Promise
		 */
		reportPageView(extraData = {}) {
			try {
				// 只有页面级组件才进行上报
				if (!this.isPageComponent) {
					return Promise.resolve({ success: false, reason: 'Not a page component' })
				}

				// 获取当前路由信息
				const currentPath = this.$route.fullPath
				const currentRoute = this.$route.name || 'unknown'

				// 基础上报数据
				const data = {
					path: currentPath,
					route: currentRoute,
					timestamp: Date.now(),
					deviceType: this.deviceType,
					// 可以添加其他需要上报的信息
					...extraData,
				}

				// 发送上报请求到/api代理，由后端转发
				return axios
					.post('/api', data, {
						params: {
							url: '/report', // 指定这是一个上报请求
						},
					})
					.catch((error) => {
						console.error('Failed to report page view:', error)
						return { success: false, error: error.message }
					})
			} catch (error) {
				console.error('Error in reportPageView:', error)
				return Promise.resolve({ success: false, error: error.message })
			}
		},
	},
	// 在页面激活时自动上报
	activated() {
		this.reportPageView()
	},
	// 在页面挂载时上报（对于不使用keep-alive的页面）
	mounted() {
		// 避免与activated重复上报
		if (!this.$vnode || !this.$vnode.data || !this.$vnode.data.keepAlive) {
			this.reportPageView()
		}
	},
}
